import { render, staticRenderFns } from "./upData.vue?vue&type=template&id=3d48d662&scoped=true&"
import script from "./upData.vue?vue&type=script&lang=js&"
export * from "./upData.vue?vue&type=script&lang=js&"
import style0 from "./upData.vue?vue&type=style&index=0&id=3d48d662&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d48d662",
  null
  
)

export default component.exports